import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import i18n from '../helpers/i18n';

import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  root: {
    padding: theme.spacing.unit * 2,
    position: "relative"
  }
});

class Page extends Component{

  componentDidMount(){
    this.updatePageTitle();
    
    // Listen for language changes to update title
    this.i18nLanguageChangedHandler = () => {
      this.updatePageTitle();
    };
    i18n.on('languageChanged', this.i18nLanguageChangedHandler);
  }

  componentDidUpdate(prevProps) {
    // Update title if it changed
    if (prevProps.title !== this.props.title) {
      this.updatePageTitle();
    }
  }

  componentWillUnmount() {
    // Remove language change listener
    if (this.i18nLanguageChangedHandler) {
      i18n.off('languageChanged', this.i18nLanguageChangedHandler);
    }
  }

  updatePageTitle = () => {
    const { title, t } = this.props;
    const pageTitleElement = document.getElementById("pageTitle");
    
    if (pageTitleElement && title) {
      // Map common string values to translation keys
      const titleToKeyMap = {
        "Dashboard": "dashboard",
        "Users": "users",
        "Stations": "stations",
        "Historical Records": "historical-records",
        "Station Realtime Data": "station-realtime-data",
        "Station Statistics": "station-statistics",
        "Forecasting": "forecasting",
        "Fault Overview": "system-fault",
        "Stations Health": "station-health",
        "Download": "download",
        "Error Reports": "errors-reports",
        "New user": "new-user",
        "Edit user": "edit-user",
        "New station": "new-station",
        "Edit station": "edit-station"
      };
      
      // Try to get translation key from map, or use title as-is
      const translationKey = titleToKeyMap[title] || title.toLowerCase().replace(/\s+/g, '-');
      
      // Try to translate, fallback to original title if translation doesn't exist
      const translatedTitle = t(translationKey, { defaultValue: title });
      pageTitleElement.innerHTML = translatedTitle;
    }
  }

  render(){
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        {this.props.children}
      </div>
    )
  }
}

Page.propTypes = {
  classes: PropTypes.object.isRequired,
  title: PropTypes.string
}

export default withTranslation()(withStyles(styles)(Page));